import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { removeLoadingKey } from '../helpers/common';

export const ReportSendHistoryLoadingKeys = {
  getSendHistory: 'REPORT_SEND_HISTORY_GET_SEND_HISTORY',
};

const initialState = {
  sendHistory: {},
  loading: false,
  loadingKeys: [],
  error: null,
};

export const getReportSendHistory = createAsyncThunk(
  'reportSendHistory/getSendHistory',
  async (reportType, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/reports/${reportType}/send-history`);
      return { reportType, data };
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue({ reportType, error: error.response.data.error || error.response.data });
      }
      return rejectWithValue({ reportType, error: 'Failed to load send history' });
    }
  }
);

export const reportSendHistory = createSlice({
  name: 'reportSendHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReportSendHistory.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, ReportSendHistoryLoadingKeys.getSendHistory];
        state.error = null;
      })
      .addCase(getReportSendHistory.fulfilled, (state, action) => {
        state.loading = false;
        const { reportType, data } = action.payload;
        state.sendHistory[reportType] = data?.sendHistory || [];
        state.loadingKeys = removeLoadingKey(ReportSendHistoryLoadingKeys.getSendHistory, state.loadingKeys);
        state.error = null;
      })
      .addCase(getReportSendHistory.rejected, (state, action) => {
        state.loading = false;
        const { reportType, error } = action.payload || {};
        if (reportType) {
          state.sendHistory[reportType] = [];
        }
        state.error = error || action.error?.message || 'Failed to load send history';
        state.loadingKeys = removeLoadingKey(ReportSendHistoryLoadingKeys.getSendHistory, state.loadingKeys);
      });
  },
});

export default reportSendHistory.reducer;
